import { z } from 'zod'
import { NotificationType } from '../../enums'

export const notificationResponseSchema = z.object({
  id: z.string().guid(),
  userId: z.string().guid(),
  type: z.nativeEnum(NotificationType),
  title: z.string(),
  message: z.string(),
  metadata: z.record(z.string(), z.unknown()).default({}),
  link: z.string(),
  read: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type NotificationResponseDto = z.infer<typeof notificationResponseSchema>
